import isNil from './isNil';
import not from './not';

const isNotNil = not(isNil);
export default isNotNil;
